/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Grid,
  Hidden,
  Avatar,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
} from '@material-ui/core';
import classNames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';
import isEmpty from 'lodash/isEmpty';
import ADGMItemDetails from 'aurora-components/ADGMItemDetails/ADGMItemDetails';
import { ADGMPanel } from 'aurora-components';
import { isArray } from 'lodash';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import MainProfile from 'aurora-images/Man.svg';
import Default from 'aurora-images/Default.svg';
import styles from './styles';

function checkWithOfColoumn(fullWidth, EqualGaps, index) {
  const ColMap = {
    0: 5,
    1: 3,
  };
  if (fullWidth) {
    return 12;
  }
  if (EqualGaps) {
    return 4;
  }
  return ColMap[index];
}

// eslint-disable-next-line react/prop-types
function Body({ classes, Labels, fullWidth, defaultImage = 'Person', imageUrl }) {
  const EqualGaps = Labels?.length > 3;
  return (
    <Box sx={{ display: 'flex' }}>
      <Hidden smDown>
        <Box item md={1}>
          <Avatar
            className={classes.avatarImg}
            alt='avatar img'
            src={imageUrl || (defaultImage === 'Person' ? MainProfile : Default)}
          />
        </Box>
      </Hidden>
      <Box item md={11}>
        <Grid container spacing={2}>
          {!isEmpty(Labels) &&
            Labels?.map(({ label, value }, index) => (
              <>
                <Grid
                  item
                  style={{ width: '100%' }}
                  xs={12}
                  sm={checkWithOfColoumn(fullWidth, EqualGaps, index) || 4}
                  key={label}
                  className={classes.divider}
                >
                  {index === 0 ? (
                    <div className={classes.avatarDiv}>
                      <Hidden mdUp>
                        <Avatar
                          alt='Person Image'
                          src={imageUrl || (defaultImage === 'Person' ? MainProfile : Default)}
                          className={classes.avatarImg}
                        />
                      </Hidden>
                      {typeof value !== 'string' ? (
                        <Typography variant='body1' className={classNames(classes.body1, classes.lightThinValue)}>
                          {value}
                        </Typography>
                      ) : (
                        <div>
                          <ADGMItemDetails
                            label={label}
                            labelClass={classes.lightThinLable}
                            value={value}
                            valueClass={classes.lightThinValue}
                          />
                        </div>
                      )}
                    </div>
                  ) : (
                    <ADGMItemDetails
                      label={label}
                      labelClass={classes.lightThinLable}
                      value={value}
                      valueClass={classes.lightThinValue}
                    />
                  )}
                </Grid>
              </>
            ))}
        </Grid>
      </Box>
    </Box>
  );
}

// eslint-disable-next-line react/prop-types
function MobileBody({ classes, Labels, fullWidth, expanded, setExpanded, defaultImage = 'Person', imageUrl }) {
  const EqualGaps = Labels?.length > 3;
  return (
    // <div style={{ marginTop: 8, marginBottom: 8 }}>
    <Accordion expanded={expanded} onChange={() => setExpanded(!expanded)} disableGutters elevation={0}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ height: 50, padding: 0 }}>
        <div className={classes.flexCenter}>
          <div className={classes.accordianHeaderWithData}>
            <Avatar
              className={classes.avatarImg}
              alt='avatar img'
              src={imageUrl || (defaultImage === 'Person' ? MainProfile : Default)}
            />
            <div className={classes.textRow}>
              <Typography style={{ fontSize: 12, color: '#130F26', fontWeight: 500 }}>{Labels[0].value}</Typography>
            </div>
          </div>
        </div>
      </AccordionSummary>
      <AccordionDetails style={{ paddingLeft: 8 }}>
        <>
          <Grid item container md={11} spacing={2} className={classes.content}>
            {!isEmpty(Labels) &&
              Labels?.map(({ label, value }, index) => (
                <>
                  {index !== 0 && (
                    <Grid
                      item
                      xs={12}
                      sm={checkWithOfColoumn(fullWidth, EqualGaps, index) || 4}
                      key={label}
                      className={classes.divider}
                    >
                      <ADGMItemDetails
                        label={label}
                        labelClass={classes.lightThinLable}
                        value={value}
                        valueClass={classes.lightThinValue}
                      />
                    </Grid>
                  )}
                </>
              ))}
          </Grid>
        </>
      </AccordionDetails>
    </Accordion>
    // </div>
  );
}

const ADGMPanelParty = ({
  classes,
  Title,
  headerChip,
  isAccordion,
  fullWidth,
  extraHeaderComponents,
  removeBorder,
  entities,
}) => {
  const [show, setShow] = useState(false);
  const [expanded, setExpanded] = useState(false);

  console.log(Title, entities);

  return (
    <ADGMPanel
      {...{
        isAccordion,
        classes,
        extraHeaderComponents,
        headerChip,
        title: Title,
        removeBorder,
      }}
    >
      <Grid className={classes.container}>
        {isArray(entities) ? (
          <>
            <Hidden xsDown>
              {(show ? entities : entities?.slice(0, 1)).map(entity => (
                <Body
                  key={entity?.id}
                  imageUrl={entity?.imageUrl}
                  defaultImage={entity?.defaultImage}
                  Labels={entity?.labels}
                  classes={classes}
                  fullWidth={fullWidth}
                />
              ))}
            </Hidden>
            <Hidden smUp>
              {entities?.map((ele, index) => (
                <>
                  {index !== 0 && <div className={classes.dropDownDivider} />}
                  <MobileBody
                    key={ele?.id}
                    Labels={ele?.labels}
                    classes={classes}
                    fullWidth={fullWidth}
                    show={show}
                    expanded={expanded}
                    setExpanded={setExpanded}
                  />
                </>
              ))}
            </Hidden>
          </>
        ) : (
          <Body
            imageUrl={entities?.imageUrl}
            defaultImage={entities?.defaultImage}
            Labels={entities?.labels}
            classes={classes}
            fullWidth={fullWidth}
          />
        )}
      </Grid>

      <Hidden xsDown>
        {isArray(entities) && entities.length > 1 && (
          <div className={classes.viewAllDiv}>
            <Typography onClick={() => setShow(!show)} className={classes.viewText}>
              {show ? 'View less' : `View ${entities?.length - 1} more owner`}
              {show ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </Typography>
          </div>
        )}
      </Hidden>
    </ADGMPanel>
  );
};

ADGMPanelParty.propTypes = {
  classes: PropTypes.object.isRequired,
  headerChip: PropTypes.object,
  Title: PropTypes.string.isRequired,
  isAccordion: PropTypes.bool.isRequired,
  fullWidth: PropTypes.bool,
  extraHeaderComponents: PropTypes.node,
  removeBorder: PropTypes.bool,
  defaultImage: PropTypes.string.isRequired,
  entities: PropTypes.oneOf([PropTypes.object, PropTypes.array]).isRequired,
};
ADGMPanelParty.defaultProps = {
  fullWidth: false,
  extraHeaderComponents: null,
  headerChip: null,
  removeBorder: false,
};
export default withStyles(styles)(ADGMPanelParty);
